module.exports = __webpack_public_path__ + "images/2_loc3324d13740247de1756a021c13f3b203.svg";